module.exports = __webpack_public_path__ + "img/pic01.c7223665.png";